import { t } from "@/languages/i18n"
import { getLocalizedHref } from "@/lib/locale-utils"
import { formatTimeAgo, toImageSrc } from "@/lib/utils"
import Image from "next/image"
import Link from "next/link"

type SidebarPost = {
  id: string
  title: string
  slug: string
  summary: string
  imageUrl?: string
  publishedAt: string
  categoryId: string
  locale?: string
}

type SidebarPostsSectionProps = {
  posts: SidebarPost[]
  locale?: string
}

export default function SidebarPostsSection({ posts, locale = "vi" }: SidebarPostsSectionProps) {
  if (posts.length === 0) {
    return <p className="text-sm text-gray-500">{t("Chưa có tin nổi bật")}</p>
  }

  return (
    <div className="flex flex-col">
      {posts.map((article, index) => (
        <div key={article.id || index}>
          <Link href={getLocalizedHref(article.locale, `/${article.slug}`)} className="group image-hover flex flex-col gap-2">
            <h3 className="sm:text-lg sm:leading-[23.4px] text-base leading-[21.7px] font-semibold text-[#333] group-hover:text-[#1EAD46] transition-all duration-300">
              {article.title}
            </h3>

            <div className="flex gap-3">
              {article.imageUrl && (
                <div className="relative flex-shrink-0 w-[44%] h-[100px] overflow-hidden">
                  <Image
                    src={toImageSrc(article.imageUrl)}
                    alt={article.title}
                    fill
                    sizes="(max-width: 640px) 44vw, (max-width: 1024px) 160px, 180px"
                    className="object-cover"
                    loading="lazy"
                    quality={70}
                  />
                </div>
              )}

              <div className="flex flex-col w-[56%] justify-around">
                {article.summary && (
                  <p className="text-sm text-[#333] leading-[21.7px] font-normal line-clamp-3">{article.summary}</p>
                )}
                {article.publishedAt && (
                  <p className="text-[12px] leading-[18.6px] text-[#333] font-normal">
                    {formatTimeAgo(article.publishedAt, locale)}
                  </p>
                )}
              </div>
            </div>
          </Link>
          {index < posts.length - 1 && <hr className="my-[26px] border-0 border-t border-dashed border-[#ced4da]" />}
        </div>
      ))}
    </div>
  )
}
